import { createContext } from 'react';

import type { Tagging } from './types';

const noopTagging: Tagging = {
  track() {},
  pageView() {},
  onClick() {},
  onModal() {},
  addContext() {},
  removeContextKey() {},
};

/**
 * `TaggingContext`. `creative-ui` has no equivalent, so this reimplements the
 * minimal subset of `@engie/web-components`'s tagging API used by this app.
 */
export const TaggingContext = createContext<Tagging>(noopTagging);
